import { ComponentHeader, HomeAboutContent, HomeAboutMedia } from "@/components/ui";
import type { HomeAboutUsProps } from "@/types";
import { Grid, Box, Container } from "@mui/material";

export const HomeAbout = ({ title, subTitle }: HomeAboutUsProps) => {
  return (
    <Container maxWidth="lg">
      <ComponentHeader title={title} subTitle={subTitle} component="h2" />

      <Grid
        container
        spacing={6}
        alignItems="stretch" // important
      >
        {/* LEFT BLOCK */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
            }}
          >
            <HomeAboutContent />
          </Box>
        </Grid>

        {/* RIGHT BLOCK (Image) */}
        <Grid size={{ xs: 12, md: 6 }}>
          <HomeAboutMedia />
        </Grid>
      </Grid>
    </Container>
  );
};
